import { createContext, useContext, useState, useCallback } from "react";
import { applyTheme, getThemeMode, COLORS, STATUS_COLORS } from "../theme/colors";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(getThemeMode);

  const toggleTheme = useCallback(() => {
    const next = mode === "dark" ? "light" : "dark";
    applyTheme(next);
    // Update STATUS_COLORS to match current COLORS
    STATUS_COLORS.live = COLORS.green;
    STATUS_COLORS.paused = COLORS.orange;
    STATUS_COLORS.draft = COLORS.textDim;
    STATUS_COLORS.error = COLORS.pink;
    setMode(next);
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be inside ThemeProvider");
  return ctx;
}
